import styled from 'styled-components';

export const BuildingContainer = styled.div`
  margin-top: 18px;
  max-width: 600px;
`;
export const RadioContainer = styled.div`
  display: flex;
  gap: 30px;
  margin-bottom: 30px;
`;
export const SecondContainer = styled.div``;

export const CardContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 15px;
`;

export const Card = styled.div`
  height: 100px;
  width: 100%;
  background-color: #ebebeb;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 6px;
`;

export const Term = styled.div`
  margin-bottom: 30px;
`;
